import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { useRecoilValue } from "recoil";

import { StyledMomentIcon } from "MVVM/Views/MatchHistory/Components/Shared/Match/styledComponents";
import { TinyAvatar } from "MVVM/Views/MatchHistory/styledComponents";
import { QuickEditTitle } from "MVVM/State/quickEdit";
import { IQuickEditMoment } from "../@types";
export const Moment = ({
  moment,
  hideTimelineLabel,
}: {
  moment: IQuickEditMoment;
  hideTimelineLabel?: boolean;
}) => {
  const title = useRecoilValue(QuickEditTitle);

  return (
    <Container>
      {!hideTimelineLabel && (
        <Text variant="text.labelXSmall">{moment.timelineLabel}</Text>
      )}
      <Players>
        <TinyAvatar src={moment.player.avatar} />
        <StyledMomentIcon src={moment.icons[0]} className="hide-on-mobile" />
        {moment.victimData.map((victim) => (
          <TinyAvatar src={victim.avatar} className="hide-on-mobile" />
        ))}
      </Players>
      <MomentTitle>
        <Text
          variant="text.labelSmall"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {!title ? moment.title : title}
        </Text>
      </MomentTitle>
    </Container>
  );
};

const Container = styled(Flex)`
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  flex-wrap: wrap-reverse;
  gap: 16px;
  height: auto;
  justify-content: space-between;
  padding: 8px 12px 8px 16px;
  width: 100%;
`;

const Players = styled(Flex)`
  align-items: center;
  gap: 8px;
  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

const MomentTitle = styled(Flex)`
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
`;
